import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';

import cancelRequestLink from '@app/cancelableLink';
import { API_URL } from '@app/config';

const getCredentialsStatus = () => {
  return localStorage.getItem('SKP-CRED') || 'omit';
};

const client = new ApolloClient({
  name: 'capture',
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkErrors }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`));
      }

      if (networkErrors) console.error('networkErrors', networkErrors);
    }),
    cancelRequestLink,
    new ApolloLink((operation, forward) => {
      if (operation.variables) {
        const omitTypename = (key, value) => (key === '__typename' ? undefined : value);
        operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
      }
      return forward(operation).map((data) => {
        return data;
      });
    }),
    setContext((_, { headers }) => {
      return {
        ...headers,
        credentials: getCredentialsStatus(),
      };
    }),
    createUploadLink({
      uri: `${API_URL}graphql`,
    }),
  ]),
  cache: new InMemoryCache({}),
});

export default client;
